<template>
    <div>
        <loading :active.sync="isLoading" :is-full-page="fullPage" :loader="$store.state.spinerLoader"
            :color="$store.state.spinerColor"></loading>

        <div class="header pb-8 pt-4">
            <b-container fluid>
                <span class="mask bg-info "></span>
            </b-container>
        </div>

        <b-container fluid class="mt--6">
            <b-card>
                <div v-if="claims.length > 0">
                    <b-row>
                        Select claim to review
                    </b-row>
                    <b-row>
                        <b-form-select :options="claims" v-model="selectedClaimId"></b-form-select>
                    </b-row>
                </div>
                <div v-else>
                    No claims available for review
                </div>

                <b-row>
                    <b-col md="12" class="order-xl-1">
                        <DocumentExplorer ref="documentExplorer" v-on:updateDocuments="onUpdateDocuments"
                            :is_review="true" v-on:reviewDocument="onReviewDocument" v-on:saveChanges="onSaveChanges">
                        </DocumentExplorer>
                    </b-col>
                </b-row>
            </b-card>

        </b-container>
    </div>
</template>

<script>

import "vue-select/dist/vue-select.css";
import _ from "lodash";
import DocumentExplorer from "@/components/DocumentExplorer/DocumentExplorer.vue";
import { mapActions, mapState } from "vuex";
import mixins from "./../../mixins/common.js";
export default {
    components: {
        DocumentExplorer
    },
    mixins: [mixins],
    props: {
        code: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            claims: [],
            selectedClaimId: null,
            documentsForReview: [],
            fullPage: true,
            isLoading: false
        }
    },
    watch: {
        selectedClaimId: function () {
            this.getDocumentsForReview(this.selectedClaimId).then((data) => {
                this.$refs.documentExplorer.setDocumentsForReview(data.data.files, data.data.claimRecordId);
            });
        },
    },
    mounted() {
        this.getClaimsForReview().then((data) => {
            var sortedData = data.data.sort((a, b) => {
                return new Date(a.createdOn) - new Date(b.createdOn);
            });

            sortedData.map((claimReview) => {
                this.claims.push({ value: claimReview.claim.id, text: this.claimDropDownLabelWithCLientName(claimReview.claim) })
            })
            if (this.claims && this.claims.length) {
                this.selectedClaimId = this.claims[0].value
            }
        });

        if (this.code) {
            localStorage.setItem('microsoftCode', this.code);
            if (localStorage.getItem('downloadUrl') != null) {
                this.isLoading = true;
                this.getSharingLink({ code: this.code, downloadLink: localStorage.getItem('downloadUrl'), fullName: localStorage.getItem('fullName'), fileId: localStorage.getItem('fileId') }).then((data) => {
                    this.isLoading = false;

                    if (data.data.isError && data.data.errorCodes.includes(70008)) { // 70008 - authorization code has expired
                        localStorage.removeItem('microsoftCode', this.code);
                        this.microsoftAuthorization();
                    } else {
                        localStorage.removeItem('downloadUrl');
                        localStorage.removeItem('fullName');
                        localStorage.removeItem('fileId');
                        window.open(data.data.sharingLink, '_blank');
                    }
                });
            }
        }
    },
    methods: {
        ...mapActions("admin", ["getClaimsForReview", "getDocumentsForReviewByClaim", "getDocumentsForReview", "getS3DownloadLink", "getSharingLink", "reviewSaveChanges"]),
        onReviewDocument(document) {
            this.isLoading = true;
            this.getS3DownloadLink({ fullName: document.fullName }).then((res) => {
                var microsoftCode = localStorage.getItem("microsoftCode");
                if (microsoftCode != null) {
                    this.getSharingLink({ code: microsoftCode, downloadLink: res.data, fullName: document.fullName, fileId: document.id }).then((data) => {
                        this.isLoading = false;
                        if (data.data.isError && data.data.errorCodes.includes(70008)) { // 70008 - authorization code has expired
                            localStorage.removeItem('microsoftCode', this.code);
                            this.microsoftAuthorization();
                        } else {
                            window.open(data.data.sharingLink, '_blank');
                        }
                    });
                } else {
                    localStorage.setItem('downloadUrl', res.data);
                    localStorage.setItem('fullName', document.fullName);
                    localStorage.setItem('fileId', document.id);

                    this.microsoftAuthorization();
                }
            });
        },
        onSaveChanges(document) {
            this.isLoading = true;
            var microsoftCode = localStorage.getItem("microsoftCode");
            this.reviewSaveChanges({ code: microsoftCode, fullName: document.fullName }).then((data) => {
                if (!data.data.success.status && !data.data.success.isValidToken) {
                    this.microsoftAuthorization();
                } else {
                    this.isLoading = false;
                }
            });
        },
        microsoftAuthorization() {
            const authorizationUrl = process.env.VUE_APP_MICROSOFT_GRAPH_API_AUTHORIZATION_URL;
            const clientId = process.env.VUE_APP_MICROSOFT_GRAPH_API_CLIENT_ID;
            const redirectUri = window.location.origin;
            const url = `${authorizationUrl}?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=openid profile email`;
            window.location.href = url;
        },
        onUpdateDocuments() {
            this.claims = [];
            var selectedClaimId = this.selectedClaimId;
            this.getClaimsForReview().then((data) => {
                var sortedData = data.data.sort((a, b) => {
                    return new Date(a.createdOn) - new Date(b.createdOn);
                });

                sortedData.map((claimReview) => {
                    this.claims.push({ value: claimReview.claim.id, text: this.claimDropDownLable(claimReview.claim) })
                })
                if (this.claims && this.claims.length) {
                    if(selectedClaimId != null){
                        var isExist = this.claims.find(x => x.value == selectedClaimId);
                        if(isExist){
                            this.selectedClaimId = selectedClaimId;
                        }else{
                            this.selectedClaimId = this.claims[0].value;
                        }
                    }

                    this.getDocumentsForReview(this.selectedClaimId).then((res) => {
                        this.$refs.documentExplorer.setDocumentsForReview(res.data.files, res.data.claimRecordId);
                    });
                } else {
                    this.$refs.documentExplorer.setDocumentsForReview([], 0);
                }
            });
        }
    }
}
</script>

<style scoped></style>